import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const vipCards = ref([])

  const { proxy } = getCurrentInstance()

  async function getVipCards() {
    const res = await proxy.$http({
      type: 'get',
      url: '/Goods/getGoodsLists',
      params: {
        page: 1,
        limit: 1000,
        type: 2,
      },
    })
    if (res.code == 0) {
      vipCards.value = res.data.data
    }
  }

  onMounted(() => {
    getVipCards()
  })

  function getVipCardName(id) {
    const temp = vipCards.value.find((item) => id == item.id)
    if (temp) {
      return temp.title
    } else {
      return ''
    }
  }

  return { vipCards, getVipCardName }
}
